import React from 'react';

const MembersCard = ({ id, imageUrl, name, email, country, phone, joinedAt}) => {

    const handleCloseViewDetails = () => {
        document.querySelector(`.card${id}`).classList.add('hide')
        document.querySelector('.lang-background').classList.add('hide')
    }


    return (
        <div className={` card${id} user-card hide`}>
            <div className="view-close" onClick={handleCloseViewDetails}>
                    <i class="fas fa-times"></i>
                </div>
            <div className="pic-container">
                <div className="p-pic">
                    <img src={imageUrl} alt="" />
                </div>
            </div>
            

            <div className="card-details">
                <div className="details">
                    <h4>Full Name:</h4>
                    <p>{name}</p>
                </div>

                <div className="details">
                    <h4>Email:</h4>
                    <p>{email}</p>
                </div>

                <div className="details">
                    <h4>Country:</h4>
                    <p>{country}</p>
                </div>

                <div className="details">
                    <h4>Phone Number:</h4>
                    <p>{phone}</p>
                </div>

                <div className="details">
                    <h4>Joined At:</h4>
                    <p>{joinedAt}</p>
                </div>
                
            </div>
        </div>
    )
}

export default MembersCard